import { UiUserActivity } from '../interfaces';

/**
 * Sample user activity data, any for now since I don't really know what the actual data structure will be
 *
 * TEMPORARY ONLY, TOBEDELETED | TOBECHANGED
 */

export const MOCK_USER_ACTIVITIES: UiUserActivity[] = [
    {
        id: 1,
        activityTarget: 'Lorem Ipsum',
        activityDescription: 'Changed Password',
        createdAt: '10/01/24 12:02 AM',
    },
    {
        id: 2,
        activityTarget: 'Lorem Ipsum',
        activityDescription: 'Deleted an Account',
        createdAt: '10/01/24 12:02 AM',
    },
    {
        id: 3,
        activityTarget: 'Lorem Ipsum',
        activityDescription: 'Edit Account',
        createdAt: '10/01/24 12:02 AM',
    },
    {
        id: 4,
        activityTarget: 'Lorem Ipsum',
        activityDescription: 'Deleted an Account',
        createdAt: '10/01/24 12:02 AM',
    },
    {
        id: 5,
        activityTarget: 'Lorem Ipsum',
        activityDescription: 'Deleted an Account',
        createdAt: '10/01/24 12:02 AM',
    },
    {
        id: 6,
        activityTarget: 'Lorem Ipsum',
        activityDescription: 'Deleted an Account',
        createdAt: '10/01/24 12:02 AM',
    },
];
